<label for="p12-certificate">
    <i class="upload-icon fa-solid fa-upload"></i>
    <input (change)="onCertificateUpload($event)" type="file" id="p12-certificate" style="display: none" accept=".p12">
</label>
